module.exports = __webpack_public_path__ + "static/media/logo.6048fb4b.svg";